

// import { Box, Container } from "@mui/material";
// import { useTheme } from '@mui/material/styles';
// import { keyframes } from '@mui/system';
// import MDTypography from "components/MDTypography";
// import PersonSearchIcon from '@mui/icons-material/PersonSearch';

// const bounce = keyframes`
//   0%, 20%, 50%, 80%, 100% {
//     transform: translateY(0);
//   }
//   40% {
//     transform: translateY(-15px);
//   }
//   60% {
//     transform: translateY(-7px);
//   }
// `;

// const fadeIn = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(10px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// const rotate = keyframes`
//   0% {
//     transform: translate(-50%, -50%) rotate(0deg);
//   }
//   100% {
//     transform: translate(-50%, -50%) rotate(360deg);
//   }
// `;

// const progress = keyframes`
//   0% {
//     width: 0%;
//     opacity: 0.1;
//   }
//   100% {
//     width: 100%;
//     opacity: 1;
//   }
// `;

// const DataLoadingSpinner = () => {
//   const theme = useTheme();

//   return (
//     <Container maxWidth="sm">
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           minHeight: '70vh',
//           textAlign: 'center',
//           animation: `${fadeIn} 0.5s ease-out`,
//         }}
//       >
//         <Box
//           sx={{
//             position: 'relative',
//             width: 120,
//             height: 120,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             mb: 4,
//           }}
//         >
//           {/* Outer rotating circle */}
//           <Box
//             sx={{
//               position: 'absolute',
//               top: '50%',
//               left: '50%',
//               width: 100,
//               height: 100,
//               borderRadius: '50%',
//               border: `3px solid transparent`,
//               borderTopColor: theme.palette.info.main,
//               borderRightColor: theme.palette.info.main,
//               animation: `${rotate} 2s linear infinite`,
//             }}
//           />
          
//           {/* Inner rotating circle */}
//           <Box
//             sx={{
//               position: 'absolute',
//               top: '50%',
//               left: '50%',
//               width: 60,
//               height: 60,
//               borderRadius: '50%',
//               border: `3px solid transparent`,
//               borderBottomColor: theme.palette.info.light,
//               borderLeftColor: theme.palette.info.light,
//               animation: `${rotate} 1.5s linear infinite reverse`,
//             }}
//           />

//           {/* Icon */}
//           <PersonSearchIcon
//             sx={{
//               fontSize: 40,
//               color: theme.palette.info.main,
//               animation: `${bounce} 2s infinite`,
//               zIndex: 1,
//             }}
//           />
//         </Box>

//         <MDTypography
//           variant="h4"
//           sx={{
//             color: theme.palette.info.main,
//             mb: 3,
//             animation: `${fadeIn} 1s ease-out`,
//             fontWeight: 'medium',
//           }}
//         >
//           Loading Lead Data
//         </MDTypography>

//         {/* Progress bar container */}
//         <Box
//           sx={{
//             width: 240,
//             height: 4,
//             backgroundColor: theme.palette.grey[200],
//             borderRadius: 2,
//             overflow: 'hidden',
//             position: 'relative',
//           }}
//         >
//           {/* Animated progress bar */}
//           <Box
//             sx={{
//               height: '100%',
//               backgroundColor: theme.palette.info.main,
//               borderRadius: 2,
//               animation: `${progress} 2s infinite ease-in-out`,
//               width: 0,
//             }}
//           />
//         </Box>

//         <MDTypography
//           variant="body2"
//           sx={{
//             mt: 2,
//             color: 'text.secondary',
//             animation: `${fadeIn} 1.5s ease-out`,
//             opacity: 0.8,
//           }}
//         >
//           Please wait while we fetch the lead information...
//         </MDTypography>
//       </Box>
//     </Container>
//   );
// };

// export default DataLoadingSpinner;



import { Box, Container } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { keyframes } from '@mui/system';
import MDTypography from "components/MDTypography";
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BusinessIcon from '@mui/icons-material/Business';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ThreeSixtyIcon  from '@mui/icons-material/ThreeSixty';
// import Customer360View from "layouts/crm/Customer360View";

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-15px);
  }
  60% {
    transform: translateY(-7px);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const rotate = keyframes`
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
`;

const progress = keyframes`
  0% {
    width: 0%;
    opacity: 0.1;
  }
  100% {
    width: 100%;
    opacity: 1;
  }
`;

// Map of entity types to their respective icons
const entityIcons = {
  lead: PersonSearchIcon,
  contact: AccountCircleIcon,
  account: BusinessIcon,
  deal: AttachMoneyIcon,
  case: SupportAgentIcon,
  order: ShoppingCartIcon,
  customer360View: ThreeSixtyIcon,
  default: SearchIcon
};

const DataLoadingSpinner = ({ 
  entityType = 'default', // Type of entity being loaded
  title = 'Loading Data', // Custom title
  message = 'Please wait while we fetch the information...', // Custom message
  iconSize = 40, // Customizable icon size
  color = 'info' // Theme color to use
}) => {
  const theme = useTheme();
  
  // Get the appropriate icon for the entity type
  const IconComponent = entityIcons[entityType.toLowerCase()] || entityIcons.default;

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '70vh',
          textAlign: 'center',
          animation: `${fadeIn} 0.5s ease-out`,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: 120,
            height: 120,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 4,
          }}
        >
          {/* Outer rotating circle */}
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: 100,
              height: 100,
              borderRadius: '50%',
              border: `3px solid transparent`,
              borderTopColor: theme.palette[color].main,
              borderRightColor: theme.palette[color].main,
              animation: `${rotate} 2s linear infinite`,
            }}
          />
          
          {/* Inner rotating circle */}
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: 60,
              height: 60,
              borderRadius: '50%',
              border: `3px solid transparent`,
              borderBottomColor: theme.palette[color].light,
              borderLeftColor: theme.palette[color].light,
              animation: `${rotate} 1.5s linear infinite reverse`,
            }}
          />

          {/* Dynamic Icon */}
          <IconComponent
            sx={{
              fontSize: iconSize,
              color: theme.palette[color].main,
              animation: `${bounce} 2s infinite`,
              zIndex: 1,
            }}
          />
        </Box>

        <MDTypography
          variant="h4"
          sx={{
            color: theme.palette[color].main,
            mb: 3,
            animation: `${fadeIn} 1s ease-out`,
            fontWeight: 'medium',
          }}
        >
          {title}
        </MDTypography>

        {/* Progress bar container */}
        <Box
          sx={{
            width: 240,
            height: 4,
            backgroundColor: theme.palette.grey[200],
            borderRadius: 2,
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          {/* Animated progress bar */}
          <Box
            sx={{
              height: '100%',
              backgroundColor: theme.palette[color].main,
              borderRadius: 2,
              animation: `${progress} 2s infinite ease-in-out`,
              width: 0,
            }}
          />
        </Box>

        <MDTypography
          variant="body2"
          sx={{
            mt: 2,
            color: 'text.secondary',
            animation: `${fadeIn} 1.5s ease-out`,
            opacity: 0.8,
          }}
        >
          {message}
        </MDTypography>
      </Box>
    </Container>
  );
};

export default DataLoadingSpinner;